import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const HaitiFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14904'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14904)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 6.53333H20V0H0V6.53333Z'
					fill='#112EBC'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V6.53333H0V14Z'
					fill='#E3264A'
				/>
				<rect
					x='6.66602'
					y='4.66663'
					width='6.66667'
					height='5.6'
					rx='0.666667'
					fill='url(#paint0_linear_2332_14904)'
				/>
				<mask
					id='mask1_2332_14904'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='6'
					y='4'
					width='8'
					height='7'>
					<rect
						x='6.66602'
						y='4.66663'
						width='6.66667'
						height='5.6'
						rx='0.666667'
						fill='white'
					/>
				</mask>
				<g mask='url(#mask1_2332_14904)'>
					<path
						d='M6.99935 9.93324V9.5411L8.16229 8.97126C8.4819 8.81465 8.83309 8.73324 9.189 8.73324H10.8097C11.1656 8.73324 11.5168 8.81465 11.8364 8.97126L12.9993 9.5411V9.93324H6.99935Z'
						fill='#AABCAE'
						stroke='#366C14'
						strokeWidth='0.666667'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M9.99888 8.39998C10.7879 8.39998 11.4275 7.77317 11.4275 6.99998C11.4275 6.22678 10.7879 5.59998 9.99888 5.59998C9.20991 5.59998 8.57031 6.22678 8.57031 6.99998C8.57031 7.77317 9.20991 8.39998 9.99888 8.39998Z'
						fill='#D4B872'
					/>
					<path
						d='M7.95247 8.36981C7.95247 8.09183 8.27271 7.93598 8.49147 8.10749L9.38311 8.80653C9.50939 8.90554 9.65355 8.97003 9.80312 9.00002H8.28581C8.10171 9.00002 7.95247 8.85078 7.95247 8.66669V8.36981ZM11.7144 9.00002H10.1971C10.3466 8.97003 10.4908 8.90554 10.6171 8.80653L11.5087 8.10749C11.7275 7.93598 12.0477 8.09183 12.0477 8.36981V8.66669C12.0477 8.85078 11.8985 9.00002 11.7144 9.00002Z'
						fill='#C28321'
						stroke='#0D3488'
						strokeWidth='0.666667'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M9.15338 6.17138C8.94012 5.96238 9.08809 5.59998 9.38669 5.59998H10.6111C10.9097 5.59998 11.0576 5.96239 10.8444 6.17138L10.2322 6.77133C10.1026 6.89835 9.89518 6.89835 9.76557 6.77133L9.15338 6.17138Z'
						fill='#216C30'
					/>
				</g>
			</g>
			<defs>
				<linearGradient
					id='paint0_linear_2332_14904'
					x1='6.66602'
					y1='4.66663'
					x2='6.66602'
					y2='10.2666'
					gradientUnits='userSpaceOnUse'>
					<stop stopColor='white' />
					<stop
						offset='1'
						stopColor='#F0F0F0'
					/>
				</linearGradient>
			</defs>
		</svg>
	);
};

export default HaitiFlagIcon;
